module.exports = __webpack_public_path__ + "static/media/bkg-vins.ba112342.jpg";